import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "./flexproducts";
import Header from "../headers_footer/header";
import Topnav from "../headers_footer/Topnav";

const Skincare = () => {

return (

<div>
<Navbar />
<Flexproducts type="skincare" />
<Header></Header>

</div>

);
};

export default Skincare;